import { render, staticRenderFns } from "./SideBarLeft.vue?vue&type=template&id=f18e40b2&scoped=true&"
import script from "./SideBarLeft.vue?vue&type=script&lang=js&"
export * from "./SideBarLeft.vue?vue&type=script&lang=js&"
import style0 from "./SideBarLeft.vue?vue&type=style&index=0&id=f18e40b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18e40b2",
  null
  
)

export default component.exports